module.exports = __webpack_public_path__ + "static/media/add-circle-icon.9a891f05.svg";